import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id C9B8EF68-CB6B-4B4E-BEEC-4BC30C04BE5F
 * name view-array-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-array-outline.svg
 * tags
 * - View 
 */
export const ViewArrayOutlineIcon = createSvgIcon(<><path d="M15 7V16H10V7H15M21 5H18V18H21V5M17 5H8V18H17V5M7 5H4V18H7V5Z" /></>, 'ViewArrayOutlineIcon');
export default ViewArrayOutlineIcon